<template>
  <div>
    <h4 class="mt-4 mb-4 pr-5 pl-5 text-danger" v-text="$t('view_schedule')"></h4>
    <vs-divider class="mt-2 mb-6"></vs-divider>
    <div class="ml-5 mr-5">
      <shared-view-schedule></shared-view-schedule>
    </div>
  </div>
</template>

<script>
import SharedViewSchedule from '@/views/Shared/Schedules/View'
import { EventBus } from '@/../eventbus.js'

export default {
  name: 'Window.Schedule.View',
  components: {
    SharedViewSchedule
  },
  mounted () {
    EventBus.$emit('initViewScheduleModal', { id: this.$route.params.id })
  }
}
</script>

<style scoped>

</style>
